import ApiService from '../../index'

export const representatives = async (query) => {
  const URI = `/api/representative?${new URLSearchParams(query)}`

  const response = await ApiService.get(URI)

  return response.data
}

export const deleteRepresentative = async (id) => {
  const URI = `/api/representative/${id}`

  const response = await ApiService.delete(URI)

  return response
}

export const addRepresentative = async (representative) => {
  const URI = `/api/representative`

  const response = await ApiService.post(URI, representative)

  return response.data
}

export const updateRepresentative = async (representative) => {
  const URI = `/api/representative/${representative.id}`

  const response = await ApiService.patch(URI, representative)

  return response.data
}
